import BaseBridge from 'config/bridge/BaseBridge'
import BaseService from 'config/bridge/BaseService'
import { BridgeMockUserInfo } from 'config/bridge/BridgeMock'
import useBoundState from 'store'
import { IMonitoringRequest } from 'store/monitoring/types'

export default class MonitoringService {
  static async postMonitoring({ eventName, params }: IMonitoringRequest) {
    let headers = {}
    const data = { ...params }
    const { utmCampaign } = useBoundState.getState()

    if (BaseBridge.isBrowser()) {
      headers = {
        'x-inter-user-bank-account': BridgeMockUserInfo.account,
        utm_campaign: utmCampaign,
        event_name: eventName,
      }
    } else {
      headers = {
        utm_campaign: utmCampaign,
        event_name: eventName,
      }
    }

    try {
      await BaseService.doExecute({
        method: 'POST',
        endpoint: `${process.env.REACT_APP_API_CAPITALIZATION}/monitoring`,
        headers,
        data,
      })
    } catch (error) {
      console.error('Error posting monitoring:', error)
    }
  }
}
